import { useState, useEffect, useRef } from "react";
import { Bell, Settings, LogOut, User } from "lucide-react";
import { getUserData } from "../../../infrastructure/storage/tokenStorage";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const UserMenu = () => {
  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationsRef = useRef(null);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const notifications = [
    {
      id: 1,
      title: "Backup completed",
      message: "bkp-LTRMS completed successfully",
      time: "5 min ago",
      read: false,
    },
    {
      id: 2,
      title: "Alert triggered",
      message: "CPU usage exceeded 80% on PAP VM",
      time: "1 hour ago",
      read: false,
    },
    {
      id: 3,
      title: "Sync finished",
      message: "Infrastructure sync completed",
      time: "2 hours ago",
      read: true,
    },
  ];

  const unreadCount = notifications.filter((n) => !n.read).length;

  useEffect(() => {
    const userData = getUserData();
    setUserEmail(userData?.email || "admin@cloudmonitor.com");
    setUserRole(userData?.role || "Administrator");
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className="flex items-center gap-1 bg-primary-cyan rounded-full px-2 py-1">
      <button
        onClick={() => {}}
        className="hidden sm:flex items-center gap-2 px-2 sm:px-3 py-2 rounded-full transition-all duration-300 hover:bg-primary-dark group"
      >
        <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center">
          <User className="w-4 h-4 text-primary-cyan" />
        </div>
        <span className="text-white text-sm font-medium hidden lg:block group-hover:text-white transition-colors">
          Profile
        </span>
      </button>

      <button
        onClick={() => navigate("/settings")}
        className="flex items-center gap-2 px-2 sm:px-3 py-2 rounded-full transition-all duration-300 hover:bg-primary-dark group"
      >
        <Settings className="w-5 h-5 text-white group-hover:text-white transition-colors" />
        <span className="text-white text-sm font-medium hidden lg:block group-hover:text-white transition-colors">
          Settings
        </span>
      </button>

      <button
        onClick={handleLogout}
        className="flex items-center gap-2 px-2 sm:px-3 py-2 rounded-full transition-all duration-300 hover:bg-primary-dark group"
      >
        <LogOut className="w-5 h-5 text-white group-hover:text-white transition-colors" />
        <span className="text-white text-sm font-medium hidden lg:block group-hover:text-white transition-colors">
          Logout
        </span>
      </button>
    </div>
  );
};

export default UserMenu;